// src/frontend/src/hooks/useHostAccount.js
// Hook for checking if a user is a host account

import { useState, useEffect } from 'react';

// Host accounts that can create global content
const HOST_ACCOUNTS = [
  'darkash650@gmail.com'
];

export const useHostAccount = (user) => {
  const [isHost, setIsHost] = useState(false);

  useEffect(() => {
    if (user && user.email) {
      setIsHost(HOST_ACCOUNTS.includes(user.email));
    } else {
      setIsHost(false);
    }
  }, [user]);

  return { isHost };
};